import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GSTModel } from '../../models/GSTModel'


export interface GSTState {
    GST: GSTModel
    GSTList: GSTModel[]
}

const initialState: GSTState = {
    GST: {} as GSTModel,
    GSTList: [],
}

export const GSTSlice = createSlice({
    name: 'gst',
    initialState,
    reducers: {
        setGST: (state, action: PayloadAction<GSTModel[]>) => {
            state.GSTList = action.payload
        },
        saveGST: (state, action: PayloadAction<GSTModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: GSTModel = { Id: 0, GSTValue: room.GSTValue }
                let currentRoom =
                    state.GSTList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.GSTValue = room.GSTValue
            } else {
                room.Id = (Math.max(...state.GSTList.map((c) => c.Id)) || 0) + 1
                state.GSTList.push(room)
            }
        },
        getGSTById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let GST: GSTModel = {} as GSTModel
            if (id > 0) {
                let currentGST: GSTModel[] = state.GSTList
                GST = currentGST.find((c) => c.Id === id) || ({} as GSTModel)
            }

            state.GST = GST
        },
        deleteGST: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentGST: GSTModel[] = state.GSTList
                state.GSTList = currentGST.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setGST, saveGST, getGSTById, deleteGST } =
GSTSlice.actions

export default GSTSlice.reducer
